import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import EnrollmentScheduleLabel from 'flow-doctor-lib/components/common/EnrollmentScheduleLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkEnrollScheduledAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.BULK_ENROLL_SCHEDULED_jsx",
      elements: {
        ObjectNameLabel,
        EnrollmentScheduleLabel,
        b: 'b'
      },
      options: {
        objectNameLabel: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        enrollmentScheduleLabel: {
          enrollmentSchedule: diagnosisReason.enrollmentSchedule
        }
      }
    })
  });
};
export default BulkEnrollScheduledAnalysisDetails;